export const GT = ['Alla','älg','dovhjort','kronhjort','rådjur','vildsvin','fasan','kanadagås'];
export const GL: Record<string,string> = { Alla:'Alla jakter', älg:'Älg', dovhjort:'Dovhjort', kronhjort:'Kronhjort', rådjur:'Rådjur', vildsvin:'Vildsvin', fasan:'Fasan', kanadagås:'Kanadagås' };

export function statusColor(s: string, T: { success: string; amber: string; textMuted: string; danger: string; textSub: string }): string {
  switch(s.toLowerCase()) {
    case 'aktiv': case 'active': case 'pågående': return T.success;
    case 'planerad': case 'planned': case 'pending': return T.amber;
    case 'avslutad': case 'completed': case 'done': return T.textMuted;
    case 'on_track': return T.success;
    case 'behind': return T.danger;
    default: return T.textSub;
  }
}

export function statusLabel(s: string): string {
  switch(s.toLowerCase()) {
    case 'aktiv': case 'active': return 'Aktiv';
    case 'planerad': case 'planned': case 'pending': return 'Planerad';
    case 'avslutad': case 'completed': case 'done': return 'Avslutad';
    case 'on_track': return 'I fas';
    case 'behind': return 'Efter';
    default: return s;
  }
}
